import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class GlobalService {

    public upgradeActive$: Observable<object>;
    private upgradeActiveSource = new Subject<object>();

    constructor(
    ) {
        this.upgradeActive$ = this.upgradeActiveSource.asObservable();
    }

    upgradeToggle(purchecked, prechecked) {
        this.upgradeActiveSource.next({ 'purchecked': purchecked, 'prechecked': prechecked });
    }

    createGetApiPath(path, params) {
        let i = 1;
        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                let len = Object.keys(params).length;
                if (len == 1) {
                    path = path + '?' + key + '=' + params[key];
                } else if (len == 0) {
                    path = path;
                } else if (i == 1) {
                    path = path + '?' + key + '=' + params[key] + "&";
                } else if (len == i) {
                    path = path + key + '=' + params[key];
                } else {
                    path = path + key + '=' + params[key] + "&";
                }
                i++;
            }
        }
        return path;
    }
}


// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/global.service.ts